import { render } from "./RelatedKeywords.vue?vue&type=template&id=f0800d3e"
import script from "./RelatedKeywords.vue?vue&type=script&lang=js"
export * from "./RelatedKeywords.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__